<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-white">Add A New Item</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body has-background-dvodark">
                <b-field label="Serial #">
                    <b-input v-model="serial">
                    </b-input>
                </b-field>
                <b-field label="PO #">
                    <b-input v-model="poNumber">
                    </b-input>
                </b-field>
                <b-field label="Order #">
                    <b-input v-model="orderNumber">
                    </b-input>
                </b-field>
                <b-field label="User To Add">
                    <b-select expanded v-model="selectedUser" placeholder="User">
                        <option class="has-text-white" selected="selected"> {{ selectedUser }}
                        </option>
                        <option class="has-text-white" v-for="option in users" :value="option"
                            :key="option.id">
                            {{ option.email}}
                        </option>
                    </b-select>
                </b-field>
                <b-field label="Product To Add">
                    <b-select expanded v-model="selectedProduct" placeholder="User">
                        <option class="has-text-white" selected="selected"> {{ selectedProduct }}
                        </option>
                        <option class="has-text-white" v-for="option in products" :value="option"
                            :key="option.id">
                            {{ option.description }}
                        </option>
                    </b-select>
                </b-field>
                <b-field label="Date of purchase">
                    <b-datepicker
                    placeholder="Select a date..."
                    icon="calendar-today"
                    locale="en-US"
                    v-model="dateOfPurchase">
                    </b-datepicker>
                </b-field>
                <b-field label="Date of production">
                    <b-datepicker
                    placeholder="Select a date..."
                    icon="calendar-today"
                    locale="en-US"
                    v-model="dateOfProduction">
                    </b-datepicker>
                </b-field>
                <b-field class="file is-primary" :class="{'has-name': !!file}">
                <b-upload v-model="file" class="file-label">
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Click to upload</span>
                    </span>
                    <span class="file-name" v-if="file">
                        {{ file.name }}
                    </span>
                </b-upload>
            </b-field>
            </section>
            <footer class="modal-card-foot">
                <b-button class="is-dvogreen" @click="createItem(); $emit('close');" >Make Request</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import { API, Storage } from 'aws-amplify';
import { itemHandler} from '../graphql/mutations'
import { personReader, getProducts } from '../graphql/queries'
import { v4 as uuidv4 } from 'uuid';

export default {
    data(){
    return{
        serial: null,
        dateOfProduction: new Date(),
        dateOfPurchase: new Date(),
        users: [],
        products: [],
        selectedUser: null,
        selectedProduct: null,
        fileKey: uuidv4(),
        poNumber: null,
        orderNumber: null,
        file: null
        }
    },
    props: ['companyId'],
    methods:{
    async createItem(){
            const purchased = this.dateOfPurchase.getFullYear() + "/" + (this.dateOfPurchase.getMonth() + 1) + "/" + this.dateOfPurchase.getDate();
            const production = this.dateOfProduction.getFullYear() + "/" + (this.dateOfProduction.getMonth() + 1) + "/" + this.dateOfProduction.getDate();
            const item = {
                        request_type: 'create',
                        serial: this.serial,
                        product_id: this.selectedProduct.code,
                        person_id: this.selectedUser.id,
                        date_purchase: purchased,
                        date_production: production,
                        image_key: this.fileKey,
                        po_number: this.poNumber,
                        order_number: this.orderNumber

            }
            await API.graphql({
                query: itemHandler,
                variables:{
                    input: item
                }
            });

            await Storage.put(this.fileKey + '.png', this.file, {
                    contentType: 'image/png'
                })
                .then (result => console.log(result))
                .catch(err => console.log(err));
        },
    async getUsers() {
        const Users = await API.graphql({
            query: personReader, 
            variables: { 
                input: {
                request_type: 'read_all'
            }}
        });
        this.users = Users.data.personReader;
    },
  async getProducts() {
    const Products = await API.graphql({
      query: getProducts
    });
    this.products = Products.data.getProducts;
    },
    },
    created(){
        this.getUsers()
        this.getProducts()
    }
}
</script>
